const typesOrder = ['System', 'Speed', 'Alignment:Head', 'Alignment:Tail', 'Temperature', 'Plug', 'Pulley', 'Expansion Card 1', 'Expansion Card 2', 'NTC', 'Pulse', 'CLI', 'Analog', 'Digital'];

export default typesOrder;
